import React from 'react'
import { navigate } from 'gatsby'
import { Button } from '@chakra-ui/react'

import { UserRoutes } from '~config/routes'
import { FormSubmittedActionItem } from '../types'

interface Props {
    actionItem: FormSubmittedActionItem
    isSmall: boolean
}

export default function FormViewSubmissionAction({
    actionItem,
    isSmall,
}: Props) {
    const { id } = actionItem.client_form

    return (
        <Button
            size={isSmall ? 'xs' : 'sm'}
            variant="outline"
            colorScheme="brand"
            onClick={() => navigate(UserRoutes.ViewFormResponse(id))}
        >
            View submission
        </Button>
    )
}
